<template>
  <div class="d-flex flex-column ma-1" style="gap: 8px">
    <div v-for="option in choices" :key="option.value">
      <div
        class="semiglutide__option-container d-flex"
        :class="{ selected: option.value === selectedType }"
        @click="onClick(option.value)"
      >
        <div class="flex-grow-1">
          <h2 :class="{ 'mt-1': !getChoiceTitle(option) }">
            {{ option.name }}
          </h2>

          <!-- SUBOPTIONS -->

          <div
            v-if="selectedType === option.value && selectedType && subOptions && subOptions.length"
            class="pl-4 mt-4 d-flex"
            style="gap: 8px"
          >
            <div
              v-for="option in subOptions"
              :key="option"
              class="semiglutide__option-container d-flex"
              :class="{ selected: option === selectedSuboption }"
              @click="onClickSuboption(option)"
            >
              <div class="flex-grow-1">
                <h2>
                  {{ `${option}mg` }}
                </h2>
              </div>
              <div>
                <v-btn
                  :large="$vuetify.breakpoint.mdAndUp"
                  icon
                  :color="option === selectedSuboption ? 'success' : ''"
                >
                  <v-icon :large="$vuetify.breakpoint.mdAndUp">{{
                    option === selectedSuboption
                      ? 'mdi-check-circle'
                      : 'mdi-checkbox-blank-circle-outline'
                  }}</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div>
          <v-btn
            :large="$vuetify.breakpoint.mdAndUp"
            icon
            :color="option.value === selectedType ? 'success' : ''"
          >
            <v-icon :large="$vuetify.breakpoint.mdAndUp">{{
              option.value === selectedType
                ? 'mdi-check-circle'
                : 'mdi-checkbox-blank-circle-outline'
            }}</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.semiglutide__option-container {
  padding: 16px;
  background-color: white;
  border-radius: 16px;
  border: 2px solid #cbd5e1;

  cursor: pointer;

  &.selected {
    border: 2px solid transparent;
    outline: 4px solid var(--v-primary-base);

    h2 {
      color: var(--v-primary-darken1);
    }
  }
}
@media all and (max-width: 768px) {
  ::v-deep .semiglutide__option-container {
    h2 {
      font-size: 1rem;
    }
    h3 {
      font-size: 0.8rem;
    }

    p {
      font-size: 0.7rem;
    }
  }
}
</style>
<script>
/* eslint-disable camelcase */
export default {
  props: {
    question: Object,
  },
  data() {
    return {
      selectedType: null,
      selectedSuboption: null,
    };
  },

  computed: {
    choices() {
      return [
        {
          value: 'ozempic',
          name: 'Semaglutide (Ozempic or Wegovy)',
        },
        {
          value: 'rybelsus',
          name: 'Semaglutide (Rybelsus)',
        },
        {
          value: 'tirzepatide',
          name: 'Tirzepatide (Mounjaro / Zepbound)',
        },
        {
          value: 'liraglutide',
          name: 'Liraglutide (Victoza / Saxenda)',
        },
      ];
    },
    subOptions() {
      if (!this.selectedType) return [];
      return (
        {
          ozempic: ['0.25', '0.5', '1', '1.7', '2', '2.4'],
          rybelsus: ['3', '7', '14'],
          tirzepatide: ['2.5', '5', '7.5', '10', '12.5', '15'],
          liraglutide: ['0.6', '1.2', '1.8', '2.4', '3'],
        }[this.selectedType] || []
      );
    },
    selectedItem() {
      return this.question.selectedItem;
    },
  },
  methods: {
    getChoiceTitle(option) {
      const medicationName = (option.value || '').trim().split('_')[0];
      const medName = {
        ozempic: 'Semaglutide (Ozempic or Wegovy)',
        rybelsus: 'Semaglutide (Rybelsus)',
        tirzepatide: 'Tirzepatide (Mounjaro / Zepbound)',
        liraglutide: 'Liraglutide (Victoza / Saxenda)',
      }[medicationName];
      return medName;
    },
    onClick(value) {
      this.selectedType = value;
    },
    onClickSuboption(value) {
      this.selectedSuboption = value;
      const option = `${this.selectedType}_${this.selectedSuboption}`;
      console.log('OPTION: ', option);
      this.question.value = option;
    },
  },
  mounted() {
    const { surveyAnswers } = this.$store.state.registration;

    const { current_medication } = surveyAnswers;

    if (!current_medication) return;
    const [selectedType, selectedSuboption] = current_medication.split('_');

    this.selectedType = selectedType;
    this.selectedSuboption = selectedSuboption;
  },
};
</script>
